<template>
  <div id="app" class="faq" data-page="faq">
    <div class="faq-wrap">
      <div class="faq-title">FAQ</div>
      <div class="faq-text">
        <p>在 FAQ 中可以阅览玩家们经常发生的问题。</p>
        <p>
          若在阅览 FAQ
          后仍无法解决问题，请通过画面底部的「联络客服」与我们联系。
        </p>
      </div>

      <div class="faq-search-box">
        <div class="no-result"></div>
        <div class="faq-search__notice">
          可使用空格分隔多个词条进行复数内容的搜寻。
        </div>
        <div class="faq-search-group">
          <div class="faq-search__input-box">
            <input type="text" class="faq-search__input" maxlength="100" />
          </div>
          <a href="javascript:;" class="faq-search__btn">搜寻</a>
        </div>
        <div class="faq-search__result">
          搜寻结果<span class="faq-search__result-count">0</span>件
        </div>
      </div>

      <div class="faq-tab-wrap">
        <ul class="faq-tab-nav__list">
          <li class="faq-tab-nav__li current" data-tab="tab1" data-type="1">
            常见问题
          </li>
          <li class="faq-tab-nav__li" data-tab="tab2" data-type="2">
            游戏相关疑问
          </li>
          <li class="faq-tab-nav__li" data-tab="tab3" data-type="3">
            游玩前须知
          </li>
        </ul>
        <div class="faq-tab-box-wrap current" id="tab1" data-tab="tab1">
          <div class="faq-tab-box">
            <div class="faq-tab-box__qa">
              <div
                class="faq-tab-box__collapse faq-tab-box__collapse--skt"
              ></div>
            </div>
            <div class="faq-tab-box__qa">
              <div
                class="faq-tab-box__collapse faq-tab-box__collapse--skt"
              ></div>
            </div>
          </div>
        </div>
        <div class="faq-tab-box-wrap" id="tab2" data-tab="tab2">
          <div class="faq-tab-box">
            <div class="faq-tab-box__qa">
              <div
                class="faq-tab-box__collapse faq-tab-box__collapse--skt"
              ></div>
            </div>
            <div class="faq-tab-box__qa">
              <div
                class="faq-tab-box__collapse faq-tab-box__collapse--skt"
              ></div>
            </div>
          </div>
        </div>
        <div class="faq-tab-box-wrap" id="tab3" data-tab="tab3">
          <div class="faq-tab-box">
            <div class="faq-tab-box__qa">
              <div
                class="faq-tab-box__collapse faq-tab-box__collapse--skt"
              ></div>
            </div>
            <div class="faq-tab-box__qa">
              <div
                class="faq-tab-box__collapse faq-tab-box__collapse--skt"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="faq-contact-wrap">
        <div class="faq-contact-inner" id="faq_contact_us">
          <div class="faq-contact__title">联络客服</div>
          <div class="faq-contact__text">
            与我们联系之前，请先行阅览 FAQ 解答，感谢您的合作。
          </div>
          <img
            src="http://ossstatic.leiting.com/static/game/images/kf_wxcode.jpg"
            alt=""
          />
          <div class="faq-contact__notice-list">
            <p>※根据询问的内容，可能会有部分无法回答的情况。</p>
            <p>※对于中文以外的来信，可能会有部分无法回答的情况。</p>
            <p>※针对询问的内容，将会以中文回复。</p>
            <p class="faq-contact__notice-list--en">
              Please understand that all information is provided in Chinese
              only.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { articlenNews } from "@api/index";
import { mapGetters } from "vuex";

export default {
  name: "Story",
  components: {},
  computed: mapGetters(["initData"]),
  data() {
    return {
      faqType: "",
      faqList: []
    };
  },
  watch: {
    initData(e) {
      if (!e.frament.length) return;
      let that = this;
      e.frament.map(e => {
        const __content = that
          .$("<div>")
          .html(e.content)
          .text();
        if (e.position === "content_us") {
          that.$("#faq_contact_us").html(__content);
        }
      });
    }
  },
  mounted: function() {
    window.$("#LT_age").remove();
    let that = this;
    that.initPage(that.faqType);
    that.$(".faq-tab-nav__li").on("click", function() {
      var tab = that.$(this).attr("data-tab");
      that
        .$(this)
        .addClass("current")
        .siblings()
        .removeClass("current");
      that.$(".faq-tab-box-wrap[data-tab=" + tab + "]").addClass("current");
      that
        .$(".faq-tab-box-wrap")
        .not(that.$(".faq-tab-box-wrap[data-tab=" + tab + "]"))
        .removeClass("current");
    });

    that.$("body").on("click", ".faq-tab-box__collapse", function() {
      if (that.$(this).hasClass("slide")) {
        that.$(this).removeClass("slide");
        that
          .$(this)
          .next()
          .slideUp();
      } else {
        that.$(".faq-tab-box__collapse").removeClass("slide");
        that
          .$(".faq-tab-box__collapse")
          .next()
          .slideUp();
        that.$(this).addClass("slide");
        that
          .$(this)
          .next()
          .slideDown();
      }
    });

    that.$(".faq-search__btn").on("click", function() {
      var findKey = that.$(".faq-search__input").val();
      that.initPage(findKey);
    });
  },
  methods: {
    faqHTMLRender(data) {
      var faqHTML =
        '<div class="faq-tab-box__qa" data-seq="' +
        data.seq +
        '">\
            <div class="faq-tab-box__collapse">' +
        data.title +
        '</div>\
            <div class="faq-tab-box__inner"><div style="padding:28px 38px">' +
        data.content +
        " </div></div>\
        </div>";

      return faqHTML;
    },
    handleFaq(data) {
      let that = this;
      that.faqList = data.new_list.map(e => {
        let type = "";
        switch (e.class_id) {
          case 15:
            type = 1;
            break;
          case 16:
            type = 2;

            break;
          case 17:
            type = 3;

            break;
        }
        return {
          content: that
            .$("<div>")
            .html(e.detail)
            .text(),
          seq: e.content_id,
          title: e.title,
          type
        };
      });

      var HTML1 = "";
      var HTML2 = "";
      var HTML3 = "";
      that.faqList.forEach(function(v) {
        switch (v.type) {
          case 1:
            HTML1 += that.faqHTMLRender(v);
            return HTML1;
          case 2:
            HTML2 += that.faqHTMLRender(v);
            return HTML2;
          case 3:
            HTML3 += that.faqHTMLRender(v);
            return HTML3;
        }
      });
      that
        .$("#tab1")
        .find(".faq-tab-box")
        .html(HTML1);
      that
        .$("#tab2")
        .find(".faq-tab-box")
        .html(HTML2);
      that
        .$("#tab3")
        .find(".faq-tab-box")
        .html(HTML3);
    },
    initPage(keyword) {
      let that = this;
      articlenNews({
        class_id: 14,
        keyword,
        page: 0
      }).then(res => {
        that.handleFaq(res);
      });
    }
  }
};
</script>
<style scoped></style>
